let deviceIdPromise: Promise<string> | null = null;

export async function getFingerprintDeviceId(): Promise<string> {
  if (typeof window === 'undefined') {
    throw new TypeError('FingerprintJS is only available in browser');
  }

  if (!deviceIdPromise) {
    deviceIdPromise = import('@fingerprintjs/fingerprintjs')
      .then(async module => {
        const fingerprint = await module.default.load();
        const result = await fingerprint.get();
        return result.visitorId;
      })
      .catch(error => {
        deviceIdPromise = null;
        throw error;
      });
  }

  return deviceIdPromise;
}
